import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API } from "../constants";
import WishlistButton from "./WishlistButton";

const RelatedProducts = ({ productId }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(`${API}/products/${productId}/related?limit=6`);
        if (!cancelled) setItems(r.data || []);
      } catch {
        if (!cancelled) setItems([]);
      }
    })();
    return () => { cancelled = true; };
  }, [productId]);

  if (items.length === 0) return null;

  return (
    <div className="mt-12" data-testid="related-products-section">
      <h2 className="font-heading text-2xl tracking-wide mb-6">YOU MIGHT ALSO LIKE</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-testid="related-products-grid">
        {items.map((p) => (
          <div key={p.product_id} className="bg-[#121212] border border-white/5 rounded-sm overflow-hidden group relative" data-testid={`related-${p.product_id}`}>
            <div className="absolute top-2 right-2 z-10">
              <WishlistButton productId={p.product_id} size="sm" showTooltip={false} />
            </div>
            <Link to={`/products/${p.product_id}`}>
              <div className="aspect-square bg-[#0A0A0A] overflow-hidden">
                <img
                  src={p.image_url || "https://images.unsplash.com/photo-1692486407015-3a47e4c1181c"}
                  alt={p.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                  onError={(e) => { e.currentTarget.src = "https://images.unsplash.com/photo-1692486407015-3a47e4c1181c"; }}
                />
              </div>
              <div className="p-3">
                <p className="text-white text-xs leading-tight line-clamp-2 mb-1 group-hover:text-[#D62828] transition-colors">{p.name}</p>
                <p className="text-[#D62828] font-bold text-sm">${p.online_price?.toFixed(2)}</p>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedProducts;
